import { render, staticRenderFns } from "./Custom.vue?vue&type=template&id=930cc21e&"
import script from "./Custom.vue?vue&type=script&lang=ts&"
export * from "./Custom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports